module.exports = __webpack_public_path__ + "static/media/chatbot.a3680830.svg";